/** Паркоин как предмет: своя монета, а не эмодзи.
 *
 * Эмодзи 🪙 на части устройств рисуется квадратом — валюта, которую видно
 * через раз, не валюта. Своя монета из SVG рисуется везде одинаково, красится
 * в наш янтарь и несёт букву «P» — как настоящие монеты несут номинал.
 *
 * Id градиентов — уникальные на каждый экземпляр. Одинаковые id у нескольких
 * SVG на странице — это ссылки на первый попавшийся: стоит ему оказаться в
 * размонтированном или скрытом углу, остальные монеты теряют заливку и
 * превращаются в тот самый пустой квадрат.
 */
import { useId } from 'react';

export function CoinIcon({ size = 20, className = '' }: { size?: number; className?: string }) {
  const uid = useId();
  const face = `coin-face-${uid}`;
  const rim = `coin-rim-${uid}`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
      aria-hidden
      focusable="false"
    >
      <defs>
        <linearGradient id={face} x1="4" y1="3" x2="20" y2="21" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#ffd98a" />
          <stop offset=".55" stopColor="#f2a03d" />
          <stop offset="1" stopColor="#c97b1f" />
        </linearGradient>
        <linearGradient id={rim} x1="20" y1="4" x2="5" y2="20" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#fff3d6" />
          <stop offset="1" stopColor="#a8641a" />
        </linearGradient>
      </defs>
      {/* Ребро и поле монеты */}
      <circle cx="12" cy="12" r="11" fill={`url(#${rim})`} />
      <circle cx="12" cy="12" r="9.2" fill={`url(#${face})`} />
      {/* Чеканка: буква P с засечкой-хвостом, как на монетном штампе */}
      <path
        d="M9.4 17.2V7h4.1c1.9 0 3.2 1.15 3.2 2.9 0 1.78-1.3 2.95-3.2 2.95h-2v4.35Zm2.1-6.1h1.8c.75 0 1.25-.45 1.25-1.2 0-.72-.5-1.15-1.25-1.15h-1.8Z"
        fill="#5a3a0c"
      />
      {/* Блик сверху: монета выпуклая, свет на ней лежит, а не заливает */}
      <path
        d="M5 8.6C6.4 5.4 9.6 3.6 12.6 3.8c2.2.15 3.9 1.1 5 2.4-1.7-.9-3.9-1.4-6.3-1.1C8.9 5.4 6.6 6.7 5 8.6Z"
        fill="#fff"
        opacity=".45"
      />
    </svg>
  );
}

/** Число с монетой — так, как пишут цену: сначала знак валюты, потом номинал. */
export function CoinAmount({
  amount,
  size = 16,
  className = '',
}: {
  amount: number | string;
  size?: number;
  className?: string;
}) {
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-numeric>
      <CoinIcon size={size} />
      {amount}
    </span>
  );
}
